import * as v from "valibot";

export const fromPageParam = v.optional(v.picklist(["workflows"]));

export const detailSearchParams = v.object({
  from: fromPageParam,
});
